import { CarOwnerRecord, UserGroupRecord } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';
import { LeasedCarBadge } from '../CarDetails/LeasedCarBadge';
import { CustomerInfoCell } from '../UserGroups/CustomerInfoCell';
import { FleetViewColumnsTranslations } from './fleetViewTranslations';

type Props = {
  owners?: CarOwnerRecord[];
  fallbackUserGroup?: UserGroupRecord | null;
  translations: FleetViewColumnsTranslations;
};

export const FleetViewOwnersCell = ({ owners, fallbackUserGroup, translations }: Props) => {
  const customers =
    owners && owners.length > 0
      ? owners.map((owner) => ({
          key: owner.userGroupCarId,
          userGroup: owner.userGroup,
          fromDate: owner.fromDate
        }))
      : fallbackUserGroup
        ? [{ key: fallbackUserGroup.id, userGroup: fallbackUserGroup, fromDate: undefined }]
        : [];

  if (customers.length === 0) {
    return null;
  }

  const isMultiple = customers.length > 1;

  return (
    <div className='flex flex-col gap-1'>
      <LeasedCarBadge owners={owners} label={translations.leased} />
      {isMultiple && (
        <NoddiBadge variant='outline'>
          <NoddiIcon name='Users' size='small' />
          {translations.currentOwners(customers.length)}
        </NoddiBadge>
      )}
      {customers.map((customer) => (
        <div key={customer.key} className={cn(isMultiple && 'rounded-md border border-border p-2')}>
          <CustomerInfoCell userGroup={customer.userGroup}>
            {customer.fromDate ? (
              <span className='text-xs text-muted-foreground'>
                {translations.ownerSince(noddiFormatDate(customer.fromDate, NoddiDateFormats.DATE))}
              </span>
            ) : null}
          </CustomerInfoCell>
        </div>
      ))}
    </div>
  );
};
